export enum UITextMode {
    default,
    subdued,
    disabled,

    critical,
    warning,
    success,
    highlight,
    primary,

    overInteractive,
    overPrimary,
    overCritical
}